export default __webpack_public_path__ + "static/media/75.824df77e.svg";